import { useMemo } from "react";
import {
  Box,
  Select,
  CheckIcon,
  FormControl,
  ChevronDownIcon,
} from "native-base";
import InputErrorMessage from "../inputErrorMessage";
import "./style.css";

const Dropdown = ({
  label = "",
  name = "drop",
  selectedValues = "",
  defaultValue = "",
  setSelectedValues = () => {},
  placeholder = "Select",
  dropItems = [],
  width = "auto",
  isDisabled = false,
  isInvalid = false,
  errorMessage = "Select option",
  important = false,
  forceRemount = false,
}) => {
  const formControlKey = useMemo(() => Date.now(), [forceRemount]);

  return (
    <Box w={width}>
      <FormControl
        isInvalid={isInvalid}
        isDisabled={isDisabled}
        // key={formControlKey}
      >
        {label && (
          <FormControl.Label>
            {label} {important && <span> *</span>}
          </FormControl.Label>
        )}
        <Select
          name={name}
          defaultValue={defaultValue}
          selectedValue={selectedValues}
          placeholder={"Select " + placeholder}
          _selectedItem={{
            endIcon: <CheckIcon size="2" />,
          }}
          dropdownIcon={<ChevronDownIcon mr={4} size="3" />}
          mt={1}
          onValueChange={(itemValues) => setSelectedValues(itemValues, name)}
          style={{ fontSize: "14px", height: "36px" }}
        >
          {dropItems.map((item) => (
            <Select.Item
              key={item.value}
              label={item.label}
              value={item.value}
              style={{
                width: "200px",
                whiteSpace: "normal",
                wordWrap: "break-word",
              }}
            />
          ))}
        </Select>
        {isInvalid && <InputErrorMessage errorMessage={errorMessage} />}
      </FormControl>
    </Box>
  );
};

export default Dropdown;
